import moduleDrilling from "./../store/moduleDrilling.js";
import vSelect from 'vue-select';
import jobEntries from "./components/jobEntries.vue"
import drillingEntries from "./components/drillingEntries.vue"
import stabilisations from "./components/stabilisations.vue"
import deviationTests from "./components/deviationTests.vue"
import service from "./stagingDailyReportService.js"
import employeeService from '../admin/employees/employeeService';
import navigationSideView from './components/navigationSideView.vue'

import { FormWizard, TabContent } from "vue-form-wizard";
import {
  ValidatedInput,
  ValidationMessage,
  FormLabel
} from "../../shared/components";

export default {
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    FormLabel,
    vSelect,
    FormWizard,
    TabContent,
    jobEntries,
    drillingEntries,
    stabilisations,
    deviationTests,
    navigationSideView
  },
  data() {
    return {
      selected: [],
      model: {
        stagingDailyReportId: 0,
        reportDate: null,
        contractNumber: null,
        drillCode: null,
        vendor: null,
        projectCode: null,
        projectId: null,
        timestamp: null,
        jobEntries: [],
        drillingEntries: [],
        stabilisations: [],
        deviationsTests: [],
        companyId: -1
      },
      activeTabIndex: 0,
      selectedTab: 0,
      listEmployees: [],
      errorMsgs: [],
      projectZones: [],
      isNavigationSidebarActive: false,
      importationResults: [],
      reportHoles: [],
      isLoaded: false,
      project: null
    };
  },
  computed: {
    title() {
      return this.$t('Drilling.DailyReports.EditTitle', {
        reportDate: this.$options.filters.toDate(this.model.reportDate),
        drillCode: this.model.drillCode
      });
    },
    isInvalidProject() {
      if (this.model.projectCode === null || this.model.projectCode === undefined) {
        return false;
      }

      const project = this.projects.find(p => p.projectId === this.model.projectId || p.codes?.some(code => code.trim().toLowerCase() === this.model.projectCode.trim().toLowerCase()));
      return project === undefined;
    },
    isInvalidContract() {
      if (this.model.contractNumber === null || this.model.contractNumber === undefined) {
        return false;
      }

      const contract = this.contracts.find(c => c.code === this.model.contractNumber);
      return contract === undefined;
    },
    isInvalidDrill() {
      if (this.model.drillCode === null || this.model.drillCode === undefined) {
        return false;
      }

      const drill = this.contractDrills.find(c => c.code === this.model.drillCode);
      return drill === undefined;
    },
    contractDrills() {
      //  if a contract is selected, only return the contract company drills
      if (this.model.contractNumber !== null && this.model.contractNumber !== undefined) {
        const contract = this.contracts.find(c => c.code === this.model.contractNumber);
        if (contract !== undefined) {
          return this.$store.state.drilling.drills.filter(d => d.companyId === contract.companyId);
        }
      }

      return this.$store.state.drilling.drills;

    },
    contracts() {
      return this.$store.state.drilling.contracts.filter(c => c.mainProjectId === Number(this.$store.state.projectId));
    },
    projects() {
      return this.$store.state.drilling.projects;
    }
  },
  watch: {
    'model.contractNumber'(val) {
      if (!val)
        return;

      const contract = this.contracts.find(c => c.code === val);
      if (contract !== undefined) {
        this.model.vendor = contract.company.shortName;
        this.model.companyId = contract.company.companyId;
        return employeeService.fetchEmployeesByCompanyId(this.model.companyId).then((employees) => {
          this.listEmployees = employees.data.model;
        });
      }
    },
    'model.projectId'() {
      if (!this.isLoaded)
        return;
      this.getProject();
      return Promise.all([
        this.getZones(),
        this.getHoles()
      ]);
    }
  },

  created() {
    if (!moduleDrilling.isRegistered) {
      this.$store.registerModule("drilling", moduleDrilling);
      moduleDrilling.isRegistered = true;
    }

    // edition mode
    if (this.$route.params.stagingDailyReportId !== undefined && this.$route.params.stagingDailyReportId !== null) {
      this.model.stagingDailyReportId = this.$route.params.stagingDailyReportId;
      this.importationResults = this.$route.params.importationResults || [];
      this.refreshModel();

      // creation mode
    } else if (this.$route.params.date !== undefined && this.$route.params.date !== null) {
      this.createReport();
      this.model.reportDate = this.$route.params.date;
      this.isLoaded = true;
    }
  },
  mounted() {
    this.$refs.wizard.activateAll();
    this.$store.dispatch("drilling/fetchAllCategoriesByProjectId", Number(this.$store.state.projectId));
  },
  methods: {
    handleErrorMessage(errorMsg) {
      this.errorMsg = errorMsg;
    },
    returnToList() {
      this.$router.push({ name: 'drilling-staging', params: { date: this.model.reportDate } });
    },

    //#region Wizard Methods
    next() {
      this.$refs.wizard.nextTab();
      this.activeTabIndex++;
    },
    previous() {
      this.$refs.wizard.prevTab();
      this.activeTabIndex--;
    },
    waitForStepRefs(retries = 10, delayMs = 100) {
      const hasRefs = this.$refs
        && this.$refs.step1Observer
        && this.$refs.jobEntries
        && this.$refs.drillingEntries
        && this.$refs.stabilisations
        && this.$refs.deviationTests;

      if (hasRefs) {
        return Promise.resolve(true);
      }

      if (retries <= 0) {
        return Promise.resolve(false);
      }

      return new Promise((resolve) => {
        setTimeout(() => {
          this.$nextTick(() => {
            resolve(this.waitForStepRefs(retries - 1, delayMs));
          });
        }, delayMs);
      });
    },
    validateAllStepsAsync(navigateToTab) {
      return this.waitForStepRefs().then((ready) => {
        if (!ready) {
          return;
        }

        return Promise.all([
          this.validateStep1().catch((error) => error),
          this.validateStep2().catch((error) => error),
          this.validateStep3().catch((error) => error),
          this.validateStep4().catch((error) => error),
          this.validateStep5().catch((error) => error)
        ]).then((result) => {
          this.errorMsgs = []; // Reset error messages
          let shouldChangeTab = true;
          for (let i = 0; i < result.length; i++) {
            if (result[i] === true) continue;
            if (navigateToTab && shouldChangeTab) {
              shouldChangeTab = false;
              for (let l = 0; l < result[i].step - 1; l++) {
                setTimeout(() => {
                  this.$refs.wizard.nextTab();
                }, l * 100);
              }
            }
            this.errorMsgs.push(result[i].message);
          }
        });
      });
    },
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$refs.step1Observer.validate().then(result => {
          if (result && !this.isInvalidProject && !this.isInvalidContract && !this.isInvalidDrill) {
            resolve(true);
          } else {
            reject({ step: 1, message: this.$t('Drilling.DailyReports.Tab1') });
          }
        });
      });
    },
    validateStep2() {
      return new Promise((resolve, reject) => {
        if (this.validateJobEntries(this.$refs.jobEntries.rows)) {
          this.updateJobEntries(this.$refs.jobEntries.tasks, this.$refs.jobEntries.rows);
          this.model.comments = this.$refs.jobEntries.dailyReportComments;
          resolve(true);
        } else {
          reject({ step: 2, message: this.$t('Drilling.DailyReports.Tab2') });
        }
      });
    },
    validateJobEntries(employeeData) {
      let isValid = true;
      employeeData.forEach(data => {
        const invalidHours = data.hours.filter(h => h === null || h < 0 || h > 24);
        if (invalidHours !== null && invalidHours !== undefined && invalidHours.length > 0) {
          isValid = false;
        }
      });
      return isValid;
    },
    validateStep3() {
      return new Promise((resolve, reject) => {
        if (this.validateDrillingEntries(this.$refs.drillingEntries.innerEntries)) {
          this.model.drillingEntries = this.$refs.drillingEntries.innerEntries;
          this.$refs.deviationTests.updateTestMaxDepth();
          resolve(true);
        } else {
          reject({ step: 3, message: this.$t('Drilling.DailyReports.Tab3') });
        }
      });
    },
    validateStep4() {
      return new Promise((resolve, reject) => {
        let isValid = true;
        this.$refs.stabilisations.innerEntries.forEach(data => {
          const coreBarrelValid = data.coreBarrelId !== null && data.coreBarrelId !== undefined;
          const fromValid = data.from !== null && data.from !== undefined;
          const toValid = data.to !== null && data.to !== undefined;
          const toGreaterThanFrom = data.to >= data.from;
          const quantityValid = data.coreBarrelQuantity !== null && data.coreBarrelQuantity !== undefined;

          isValid = isValid && coreBarrelValid && fromValid && toValid && toGreaterThanFrom && quantityValid;
        });
        if (isValid) {
          this.model.stabilisations = this.$refs.stabilisations.innerEntries;
          resolve(true);
        } else {
          reject({ step: 4, message: this.$t('Drilling.DailyReports.Tab4') });
        }
      });
    },
    validateStep5() {
      return new Promise((resolve, reject) => {
        let isValid = true;
        this.$refs.deviationTests.innerTests.forEach(item => {
          if (item.instrumentId === null || item.depth === null || item.depth === '' || item.inclination === null || item.inclination === '' || item.holeId === null || item.holeId === '') {
            isValid = false;
          }
          if (item.depth > item.maxDepth) {
            isValid = false;
          }
        });
        if (isValid) {
          this.model.deviationTests = this.$refs.deviationTests.innerTests;
          resolve(true);
        } else {
          reject({ step: 5, message: this.$t('Drilling.DailyReports.Tab5') });
        }
      });
    },
    validateFromToLatestToEntries() {
      let isValid = true;

      // validate drilling entries attributes
      const invalidData = this.model.drillingEntries.filter(data => (parseInt(data.latestTo) !== 0 && parseInt(data.from) !== parseInt(data.latestTo)) ||
        // validate end of whole persisted
        (data.latestIsEndOfHole && !data.isEndOfHole))

      if (invalidData !== null && invalidData !== undefined && invalidData.length > 0) {
        isValid = false;
      }

      return isValid;
    },

    // Shift is required on every entry. Imported reports can arrive with it null, and the
    // server rejects the import in that state, so block here instead of round-tripping.
    // Unlike validateFromToLatestToEntries this is not overridable: there is no valid
    // report with a missing shift.
    validateShiftsPresent() {
      const hasNoShift = entry => entry.shift === null || entry.shift === undefined;

      return !(this.model.jobEntries || []).some(hasNoShift)
        && !(this.model.drillingEntries || []).some(hasNoShift)
        && !(this.model.stabilisations || []).some(hasNoShift)
        && !(this.model.deviationTests || []).some(hasNoShift);
    },

    validateDrillingEntries(drillingEntries) {
      let isValid = true;

      // validate holes
      drillingEntries.forEach(data => {
        const hole = this.reportHoles.find(h => h.code === data.holeNumber);
        if (hole === undefined)
          isValid = false;
      });

      // validate drilling entries attributes
      const invalidData = drillingEntries.filter(data => data.dip === null || data.dip === '' || (parseInt(data.dip) < -90 || parseInt(data.dip) > 90)
        || (data.azimut !== null && data.azimut !== '' && (parseInt(data.azimut) < 0 || parseInt(data.azimut) > 360))
        || data.coreSize === null || data.coreSize === ''
        || data.from === null || data.from === '' || parseInt(data.from) < 0
        || data.to === null || data.to === '' || parseInt(data.to) < 0 || parseInt(data.to) < parseInt(data.from))

      if (invalidData !== null && invalidData !== undefined && invalidData.length > 0) {
        isValid = false;
      }

      return isValid;
    },
    //#endregion

    refreshModel() {
      if (this.model.stagingDailyReportId !== 0) {
        this.$vs.loading();
        this.isLoaded = false;
        this.getReport().finally(() => {
          this.$vs.loading.close();
          this.getProject();
          Promise.all([
            this.getHoles(),
            this.getZones()
          ]).then(() => {
            this.isLoaded = true;
            this.$nextTick(() => {
              setTimeout(() => this.validateAllStepsAsync(true), 500);
            });
          });
        })
      } else {
        this.createReport();
        this.isLoaded = true;
      }
    },
    createReport() {
      this.model = {
        stagingDailyReportId: 0,
        reportDate: null,
        contractNumber: null,
        drillCode: null,
        vendor: null,
        projectCode: null,
        projectId: null,
        timestamp: null,
        jobEntries: [],
        drillingEntries: [],
        stabilisations: [],
        deviationTests: [],
        companyId: -1,
        comments: ''
      };
    },
    getReport() {
      return service.findById(this.model.stagingDailyReportId, this).then((response) => {
        this.model = response.data.model;
      }).catch((error) => {
        this.$vs.notify({
          color: "danger",
          title: this.$t("LoadingError"),
          text: error.message
        });
      })
    },
    updateJobEntries(tasks, newEntries) {
      const jobEntries = [];
      newEntries.forEach(entry => {
        for (let index = 0; index < tasks.length; index++) {
          if (entry.hours[index] !== 0) {
            jobEntries.push({
              stagingDailyReportId: this.model.stagingDailyReportId,
              employee: entry.employee,
              employeeName: entry.employeeName,
              employeeId: entry.employeeId,
              employeeTitleId: entry.employeeTitleId,
              shift: entry.shift,
              title: entry.title,
              note: entry.note,
              otherTaskName: tasks[index].otherTaskName,
              isOtherTask: tasks[index].isOtherTask,
              task: tasks[index].task,
              taskId: tasks[index].taskId,
              isBillable: tasks[index].isBillable,
              hours: entry.hours[index]
            });
          }
        }
      });

      this.model.jobEntries = jobEntries;
    },

    save() {
      if (Object.prototype.toString.call(this.model.reportDate) === "[object Date]") {
        this.model.reportDate = this.$options.filters.toDate(this.model.reportDate);
      }
      // Return the underlying promise so errors propagate naturally
      return service.save(this.model, this).then((response) => {
        this.model = response.data.model;
        return response;
      });
    },

    submitData() {
      this.validateAllStepsAsync(false).then(() => {
        if (this.validateFromToLatestToEntries()) {
          this.processSave();
        }
        else {
          this.$vs.dialog({
            type: "confirm",
            color: "warning",
            title: this.$t('Warning'),
            text: this.$t('Drilling.DailyReports.ConfirmSaveWithInvalidFrom'),
            accept: this.processSave
          });
        }
      })
    },
    importData() {
      this.validateAllStepsAsync(false).then(() => {
        if (!this.validateShiftsPresent()) {
          this.$vs.notify({
            color: 'danger',
            title: this.$t('Error'),
            text: this.$t('Drilling.DailyReports.ShiftRequiredBeforeImport')
          });
          return;
        }

        if (this.validateFromToLatestToEntries()) {
          this.processImportData();
        }
        else {
          this.$vs.dialog({
            type: "confirm",
            color: "warning",
            title: this.$t('Warning'),
            text: this.$t('Drilling.DailyReports.ConfirmImportWithInvalidFrom'),
            accept: this.processImportData
          });
        }
      });
    },

    processSave() {
      this.$vs.loading();
      this.save().then(() => {
        this.$notifySaveSuccess();
        this.$vs.loading.close();
        this.refreshModel();
      }).catch(() => {
        // Ensure loader is closed on error. Keep notifications to server-side handling for concurrency (409).
        this.$vs.loading.close();
      });
    },
    getNextId() {
      let nextId = 0;
      let indexOfCurrentReport = this.importationResults.findIndex(_ => _.id === this.model.stagingDailyReportId);
      while (nextId === 0 && ++indexOfCurrentReport < this.importationResults.length) {
        if (!this.importationResults[indexOfCurrentReport].isSuccess) {
          nextId = this.importationResults[indexOfCurrentReport].id;
        }
      }
      if (nextId === 0) {
        indexOfCurrentReport = this.importationResults.findIndex(_ => _.id === this.model.stagingDailyReportId);
        while (nextId === 0 && --indexOfCurrentReport >= 0) {
          if (!this.importationResults[indexOfCurrentReport].isSuccess) {
            nextId = this.importationResults[indexOfCurrentReport].id;
          }
        }
      }
      return nextId;
    },

    processImportData() {
      this.$vs.loading();
      this.save().then((result) => {
        return service.importBatch([result.data.model.stagingDailyReportId], this).then((importBatchResult) => {
          if (importBatchResult.data && importBatchResult.data.model && importBatchResult.data.model.isSuccess) {
            this.$notifySuccess(this.$t("Drilling.DailyReports.ImportCompleted"))
            if (this.importationResults && this.importationResults.length > 0) {
              const indexOfCurrentReport = this.importationResults.findIndex(_ => _.id === this.model.stagingDailyReportId);
              this.importationResults[indexOfCurrentReport].isSuccess = true;
              const nextId = this.getNextId();
              if (nextId) {
                this.$router.push({ name: 'drilling-staging-edit', params: { stagingDailyReportId: nextId, importationResults: this.importationResults } });
              } else {
                this.$router.push("/drilling/staging");
              }
            } else {
              this.$router.push("/drilling/staging");
            }
          } else {
            // Import batch failed - show message
            const message = importBatchResult && importBatchResult.data && (importBatchResult.data.message || (importBatchResult.data.model && importBatchResult.data.model.message)) || this.$t('Drilling.DailyReports.ImportFailed');
            this.$vs.notify({ color: 'danger', title: this.$t('Error'), text: message });
            // import batch failed; user can use Back to return to previous step if needed
          }
        });
      }).catch((error) => {
        // Error during save or import - show message except when server already showed concurrency (409)
        if (!(error && error.response && error.response.status === 409)) {
          const text = (error && error.response && (error.response.data && (error.response.data.message || error.response.data))) || error.message || this.$t('UnknownError');
          this.$vs.notify({ color: 'danger', title: this.$t('Error'), text });
        }
        // when running as part of import batch, user may navigate back manually; no automatic wizard reset
      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    handleTabChange(oldIndex, newIndex) {
      if (newIndex > 2) {
        this.model.stabilisations.forEach(entry => {
          const entryHole = this.reportHoles.find(h => h.code === entry.holeNumber);
          entry.holeId = entryHole === undefined ? 0 : entryHole.holeId;
        });
        this.model.deviationTests.forEach(entry => {
          const entryHole = this.reportHoles.find(h => h.code === entry.holeNumber);
          entry.holeId = entryHole === undefined ? 0 : entryHole.holeId;
        });
      }
      this.validateAllStepsAsync(false);
    },
    getZones() {
      // Get projectId first
      const project = this.getProject();
      if (!project) {
        this.projectZones = [];
        return;
      }

      const projectId = project.projectId;
      return this.$cqrsGet("drilling/zones/findByProjectId/", { params: { projectId } })
        .then((response) => {
          this.projectZones = response.data.model;
        });
    },
    toggleDataSidebar(val = false) {
      this.isNavigationSidebarActive = val;
    },
    closeSidebar() {
      this.isNavigationSidebarActive = false;
    },
    showList() {
      this.isNavigationSidebarActive = true;
    },
    hasNextReportToFix() {
      for (let i = 0; i < this.importationResults.length; i++) {
        if (this.importationResults[i].id !== this.model.stagingDailyReportId && !this.importationResults[i].isSuccess) {
          return true;
        }
      }
      return false;
    },
    getProject() {
      const projects = this.$store.state.drilling.projects;
      this.project = projects.find(p => p.projectId === this.model.projectId || p.codes.some(code => code.trim().toLowerCase() === this.model.projectCode?.trim().toLowerCase()));
      // v-select only writes projectId; keep projectCode in sync so it isn't left stale/null on save
      if (this.project && !this.project.codes?.some(code => code?.trim().toLowerCase() === this.model.projectCode?.trim().toLowerCase())) {
        this.model.projectCode = this.project.codes?.[0] ?? this.model.projectCode;
      }
      return this.project;
    },
    getUniqueHoleNumbers() {
      const holeNumbers = new Set();

      // Add hole numbers from drillingEntries
      this.model.drillingEntries.forEach(entry => {
        if (entry.holeNumber) {
          holeNumbers.add(entry.holeNumber);
        }
      });

      // Add hole numbers from deviationTests
      this.model.deviationTests.forEach(entry => {
        if (entry.holeNumber) {
          holeNumbers.add(entry.holeNumber);
        }
      });

      // Add hole numbers from stabilisations
      this.model.stabilisations.forEach(entry => {
        if (entry.holeNumber) {
          holeNumbers.add(entry.holeNumber);
        }
      });

      return Array.from(holeNumbers);
    },
    getHoles() {
      const holeNumbers = this.getUniqueHoleNumbers();
      if (!this.project) {
        this.projectZones = [];
        this.reportHoles = [];
        return;
      }
      // No hole in the report yet (new report): searching without a code filter
      // returns the first page of every hole of the project, which would then sit
      // in the hole dropdown as if those holes were linked to the report.
      if (holeNumbers.length === 0) {
        this.reportHoles = [];
        return;
      }
      const holeCodes = holeNumbers.join(',');
      const mainProjectId = Number(this.$store.state.projectId);
      const projectId = this.project.projectId;

      return this.$cqrsGet("Drilling/Holes/Search", { params: { mainProjectId, projectId, holeCodes, includeInactiveHoles: true } })
        .then((response) => {
          this.reportHoles = response.data.model;
        });
    },

    addHoleToReportHoles(hole) {
      const existingHole = this.reportHoles.find(h => h.holeId === hole.holeId);
      if (!existingHole) {
        this.reportHoles.push(hole);
      }
    }
  }
};
